import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME_API } from './constants';

export const apiProvider = new BaseApi(DMS_MODULE, NAME_API);
